type BarChartPlotAreaBottomInsetParams = {
  chartMarginBottom: number;
  containerBottom: number;
  xAxisTop: number;
};

const calculateBarChartPlotAreaBottomInset = ({
  chartMarginBottom,
  containerBottom,
  xAxisTop,
}: BarChartPlotAreaBottomInsetParams): number => {
  return Math.max(chartMarginBottom, containerBottom - xAxisTop);
};

export { calculateBarChartPlotAreaBottomInset };
